if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.slides = [];
      this.thumbs = [];
      this.activeIndex = 0;

      // Clicking the dark backdrop (outside the image/controls) closes the
      // lightbox. The base ModalDialog class skips this for ".media-modal"
      // elements, so it's wired here instead.
      this.addEventListener('click', (event) => {
        if (event.target === this || event.target === this.querySelector('.pim-dialog')) {
          this.hide();
        }
      });

      this.addEventListener('keydown', (event) => {
        if (!this.classList.contains('active')) return;
        if (event.key === 'ArrowRight') this.goTo(this.activeIndex + 1);
        if (event.key === 'ArrowLeft') this.goTo(this.activeIndex - 1);
      });
    }

    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();

      this.slides = Array.from(this.querySelectorAll('[data-pim-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-pim-thumb]'));
      this.counter = this.querySelector('[data-pim-counter]');

      const prevBtn = this.querySelector('[data-pim-prev]');
      const nextBtn = this.querySelector('[data-pim-next]');

      // The theme's own "click outside the image closes the modal" logic
      // (built for the old design, which had nothing clickable inside the
      // popup) treats these new controls as "outside" and closes the modal
      // on every click. Stop the click (and the press that precedes it)
      // from ever reaching that listener, on both the bubble and capture
      // phase, for every event type a close-on-outside-interaction check
      // might use.
      const guard = (el) => {
        if (!el) return;
        // pointerup is the one that actually matters: the base class's
        // close-on-click logic for ".media-modal" elements is wired to
        // pointerup, not click, and only spares elements matching
        // "deferred-media, product-model" (video/3D-model content).
        ['pointerdown', 'pointerup', 'mousedown', 'touchstart', 'click'].forEach((type) => {
          el.addEventListener(type, (event) => event.stopPropagation());
        });
      };
      guard(prevBtn);
      guard(nextBtn);
      guard(this.querySelector('[data-pim-thumbs]'));

      if (prevBtn) prevBtn.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.goTo(this.activeIndex + 1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(parseInt(thumb.dataset.mediaIndex, 10)));
      });
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      const targetId = this.openedBy && this.openedBy.getAttribute('data-media-id');
      let index = this.slides.findIndex((slide) => slide.getAttribute('data-media-id') === targetId);
      if (index === -1) index = 0;
      this.goTo(index, true);
    }

    goTo(index, force) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      const nextIndex = ((index % total) + total) % total;
      if (!force && nextIndex === this.activeIndex) return;

      if (window.pauseAllMedia) window.pauseAllMedia();

      if (this.slides[this.activeIndex]) this.slides[this.activeIndex].classList.remove('active');
      if (this.thumbs[this.activeIndex]) this.thumbs[this.activeIndex].classList.remove('active');

      this.activeIndex = nextIndex;

      const activeSlide = this.slides[this.activeIndex];
      activeSlide.classList.add('active');
      if (this.thumbs[this.activeIndex]) this.thumbs[this.activeIndex].classList.add('active');

      if (this.counter) this.counter.textContent = `${this.activeIndex + 1} / ${total}`;

      // Match the previous behavior: auto-load an embedded YouTube player
      // when its slide becomes active. Everything else (native video,
      // 3D models) still loads from its own poster button, same as before.
      const deferredMedia = activeSlide.querySelector('deferred-media');
      if (deferredMedia) {
        const template = deferredMedia.querySelector('template');
        const templateContent = template ? template.content : null;
        if (templateContent && templateContent.querySelector('.js-youtube') && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent();
        }
      }
    }
  });
}
